const FormAccordion = {
  elements: document.querySelectorAll<HTMLElement>('.saig-o-form-accordion'),
  isInitialized: false,
  init: function () {
    if (!this.elements || this.isInitialized) {
      return;
    }
    this.isInitialized = true;
    [].forEach.call(this.elements, this.accordionHandler);
  },
  accordionHandler: function (el: HTMLElement) {
    const header = el.querySelector<HTMLElement>('.saig-o-form-accordion__header');
    const body = el.querySelector<HTMLElement>('.saig-o-form-accordion__body');

    if (!header || !body) return;

    const toggle = () => {
      el.classList.toggle('active');
    };

    header.addEventListener('click', toggle);

    el.addEventListener('collapse', () => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });

    el.addEventListener('expand', () => {
      if (!el.classList.contains('active')) {
        el.classList.add('active');
      }
    });
  },
};

FormAccordion.init();

export { FormAccordion as FormAccordionJS };

export default FormAccordion;
